export const GET_UNSUBSCRIBE_INFO = 'GET_UNSUBSCRIBE_INFO'
export const TOGGLE_STATE = 'TOGGLE_STATE'
